import { CREATE, DELETE, EDIT } from '@/constants/api'
import { AUTH } from '@/features/auth/constants/endpoints'

export const USERS = 'users'
export const USER = 'user'

export const ENDPOINTS = {
  CREATE_USER: `/${USERS}/${CREATE}`,
  GET_USERS: `/${USERS}/`,
  GET_USER: `/${USERS}/${USER}`,
  UPDATE_USER: `/${USERS}/${EDIT}`,
  DELETE_USER: `/${USERS}/${DELETE}`,
  SEND_PASSWORD_EMAIL: `/${AUTH}/resend-verification`,
  COMPLETE_USER_SETUP: `/${USERS}/complete-setup`,
}
